<script>

import axios from "axios"
// import { formatNumber } from "./utils.js"
import { lang } from "./store.js"
// import { onMount } from "svelte";

let message = ""
let email = ""
let errEmail = false
let errMessage = false
let successResult = false
let errResult = false
let loading = false

function checkEmail (value) {
    return (value && !!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) || false
}

function send(){
    errMessage = false
    errEmail = false
    successResult = false
    errResult = false
    if(email == "" || !checkEmail(email)) errEmail = true
    if(message == "") errMessage = true
    if(errMessage || errEmail) return

    let data = {
        email: email,
        message: message
    }
    loading = true
    axios.post('/api/send-message',data, {withCredentials: true})
    .then(function (response) {
        if(response.data.success === true){
            successResult = true
        }
        else{
            errResult = true
        }

    })
    .catch(function (error) {
        // console.log(error);
        errResult = true
    });
    loading = false
}


</script>

<h3 class="title is-4 mb-7">{($lang == "cs" ? 'Pošlete nám zprávu' : 'Send us a message')}</h3>

<div class="field">
    <label for="email" class="label has-text-weight-normal" style="max-width:500px">E-mail</label>
    <div class="control">
        <input class="input" type="email" id="email" bind:value={email}>
    </div>
    {#if errEmail}
    <p class="help is-danger">{($lang == "cs" ? 'Prosím vyplňte e-mail' : 'Please fill e-mail')}</p>
    {/if}
</div>

<div class="field">
    <label for="message" class="label has-text-weight-normal" style="max-width:500px">{($lang == "cs" ? 'Zpráva' : 'Message')}</label>
    <div class="control">
        <textarea class="input" type="message" id="message" style="height:100px" bind:value={message}></textarea>
    </div>
    {#if errMessage}
    <p class="help is-danger">{($lang == "cs" ? 'Prosím vyplňte zprávu' : 'Your message should not be empty')}</p>
    {/if}
</div>

<div>
    {#if !successResult}
    <button class="button is-belle-full {(loading ? 'is-loading' : '')}" on:click={send}>
        {($lang == "cs" ? 'Odeslat zprávu' : 'Send message')}
    </button>
    {/if}
    {#if successResult}
    <p class="help si-size-6">{($lang == "cs" ? 'Zpráva byla odeslána. Ozveme se vám co nejdříve zpět' : 'Your message was send. We will get back to you as soon as possible.')}</p>
    {/if}
    {#if errResult}
    <p class="help is-danger">{($lang == "cs" ? 'Někde se stala chyba. Zkuste to znovu nebo nám pošlete e-mail' : 'There was some error. Either try again or send us an email')}</p>
    {/if}
</div>